import * as yup from 'yup'
import { VALIDATION_PATTERNS } from '../../config'

export const groupValidationSchema = yup.object({
  name: yup
    .string()
    .matches(VALIDATION_PATTERNS.ONLY_LATIN, 'Please use latin letters')
    .trim()
    .max(20, 'The text is too long, maximum number of characters is 20')
    .required('This is a required field.'),
  shortTitle: yup
    .string()
    .trim()
    .max(20, 'The text is too long, maximum number of characters is 20')
    .required('This is a required field.'),
  title: yup
    .string()
    .trim()
    .max(35, 'The text is too long, maximum number of characters is 35')
    .required('This is a required field.'),
  description: yup
    .string()
    .trim()
    .max(255, 'The text is too long, maximum number of characters is 255'),
  editorRole: yup
    .object()
    .required('This is a required field.'),
  maxFileSizeMb: yup
    .number()
    .typeError('This field must be a positive number')
    .moreThan(0, 'File size must be a positive number')
    .max(300, 'File size must be less than or equal to 300')
    .required('These characters are not allowed here.'),
})
